import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography, Stack} from 'views/components';
import {CancelOutlined} from 'views/icons';
import {Translate} from 'views/module';

import TimelineCard from './TimelineCard';
import {formatEventDateTime} from '../dateTime';

const ShiftCancelled = (props) => {
  const {deactivatedData, eventTimezone} = props;

  const timeString = formatEventDateTime(deactivatedData.timeDeactivated, eventTimezone);

  return (
    <Box>
      <TimelineCard
        timeString={timeString}
        icon={CancelOutlined}
        iconColor="#b03621"
        timeBg="#e0e0e0"
        title={<Translate expression='schedule.eventDetail.EventTimelineSection.ShiftCancelled.DeactivatedTitle' />}
      >
        <Stack spacing={1}>
          <Typography variant="body2" color="text.secondary">
            <Translate expression='schedule.eventDetail.EventTimelineSection.ShiftCancelled.DeactivatedDescription' />
          </Typography>
        </Stack>
      </TimelineCard>
    </Box>
  );
};

ShiftCancelled.propTypes = {
  deactivatedData: PropTypes.shape({
    description: PropTypes.shape({
      blob: PropTypes.string,
      editorType: PropTypes.string,
    }),
    timeDeactivated: PropTypes.string,
    newRescheduleEventRn: PropTypes.string,
  }),
  eventTimezone: PropTypes.string.isRequired,
};

export default ShiftCancelled;
